import type { LoaderFunction } from 'react-router';

import type { RouteProps } from '../../shared/RouteProps';

export const writeAReviewLoader =
  (_props: RouteProps): LoaderFunction =>
  (): string =>
    'writeAReviewLoader';
